import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cardBrandIcon' })
export class CardBrandIconPipe implements PipeTransform {
    transform(name: string): string {
        const n = (name || '').toLowerCase();
        if (n.includes('master'))                    return 'assets/icon/mastercard-brand-new.svg';
        if (n.includes('visa'))                      return 'assets/icon/visa-brand-new.svg';
        if (n.includes('hiper'))                     return 'assets/icon/hipercard-brand-new.svg';
        if (n.includes('alelo'))                     return 'assets/icon/alelo-brand-new.svg';
        if (n.includes('elo'))                       return 'assets/icon/elo-brand-new.svg';
        if (n.includes('amex') || n.includes('american')) return 'assets/icon/amex-brand.svg';
        if (n.includes('diners'))                    return 'assets/icon/diners-brand.svg';
        if (n.includes('maestro'))                   return 'assets/icon/maestro-brand.svg';
        if (n.includes('jcb'))                       return 'assets/icon/jcb-brand.svg';
        return 'assets/icon/credit-card-brand-new.svg';
    }
}
